/**
 * Application configuration
 */

import { getClientDisplayName } from './clientBranding';

const isDev = process.env.NODE_ENV === 'development';

const config = {
  API_BASE_URL: isDev ? 'http://localhost:4000' : '',
  APP_NAME: `SLAM ${getClientDisplayName()}`,
  VERSION: '1.0.0',
};

export default config;
